import { Button, Col, Label, Modal, ModalBody, Row } from "reactstrap";
import NormalInput2 from "../inputs/NormalInput2";
import MultiSelectInput from "../inputs/MultiSelectInput";
import { useState } from "react";
import VideoUploadInput from "../inputs/VideoUploadInput";
import { dummyPlaces } from "../../dummyData";

const AddCommercialModal = ({ isOpen, setisOpen }) => {
  const [commercialData, setCommercialData] = useState({
    name: "",
    type: [],
    description: "",
    video: null,
  });
  return (
    <Modal
      centered
      size="lg"
      isOpen={isOpen}
      toggle={() => setisOpen((prev) => !prev)}
    >
      <ModalBody style={{ borderRadius: "14.76px" }} className="bg-white ">
        <h4 className="f-6 text-center mt-3 mb-4 figma-shadowed-black-text">
          Add Commercial
        </h4>
        <Row className="gy-3 gx-4 m-0">
          <Col md={6}>
            <NormalInput2
              placeholder={"Write place name"}
              value={commercialData?.name}
              setValue={(v) =>
                setCommercialData((prev) => ({ ...prev, name: v }))
              }
              label={"Enter your commercial Name"}
            />
          </Col>
          <Col md={6}>
            <MultiSelectInput
              value={commercialData?.type}
              setValue={(v) =>
                setCommercialData((prev) => ({ ...prev, type: v }))
              }
              options={dummyPlaces?.map((i)=>i?.title)}
              label={"Type"}
            />
          </Col>
          <Col md={12}>
            <NormalInput2
              label={"Enter Description"}
              type={"textarea"}
              placeholder={"Write description here"}
              value={commercialData?.description}
              setValue={(v) =>
                setCommercialData((prev) => ({ ...prev, description: v }))
              }
            />
          </Col>
          <Col
            md={12}
            className="outer-transparent-shadow py-3 px-3"
            style={{ borderRadius: "10px" }}
          >
            <Col md={6}>
              <Label className="figma-input-label">Add Video</Label>
              <VideoUploadInput
                hideShadow={true}
                noPadding={true}
                value={commercialData?.video}
                setValue={(v) =>
                  setCommercialData((prev) => ({ ...prev, video: v }))
                }
                id={"commercial-video"}
              />
            </Col>
          </Col>
        </Row>
        <Row className="justify-content-center mt-5 mb-3 mx-0 ">
          <Col md={6}>
            <Button
              onClick={() => setisOpen(false)}
              className="standard-rounded-btn  full-width"
              
            >
              Done
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default AddCommercialModal;
